import { element, useElementProps } from '../../../core/elements';
import { Layout } from '../../../primitives/container/layout';
import Group from '../../../primitives/shape/Group';
import { useDonutData } from '../providers/data';
import { DonutMetric } from './donut-label';
import { DonutMarkLabels } from './donut-stack-labels';
import { DonutMarks } from './donut-stack-marks';
import { DonutTooltipOverlay } from './tooltip-overlay';
import getStackArcs from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DonutStack = element(function DonutStack(_ref) {
  let {
    data,
    valueAccessor,
    labelAccessor,
    colorAccessor,
    colorScale,
    innerRadius,
    outerRadius,
    transform
  } = _ref;
  const arcs = getStackArcs(data, valueAccessor, labelAccessor, colorAccessor, colorScale, innerRadius, outerRadius);
  return /*#__PURE__*/_jsxs(Group, {
    transform: transform,
    children: [/*#__PURE__*/_jsx(DonutMarks, {
      arcs: arcs,
      labelAccessor: labelAccessor
    }), /*#__PURE__*/_jsx(DonutMarkLabels, {
      arcs: arcs,
      hide: true
    }), /*#__PURE__*/_jsx(DonutMetric, {
      data: data,
      valueAccessor: valueAccessor,
      innerRadius: innerRadius,
      hide: false
    }), /*#__PURE__*/_jsx(DonutTooltipOverlay, {
      arcs: arcs
    })]
  });
});
export function DonutStackSlot() {
  const {
    data,
    valueAccessor,
    labelAccessor,
    colorAccessor,
    colorScale,
    innerRadius,
    outerRadius,
    width,
    height
  } = useDonutData();
  const layoutProps = useElementProps(Layout);
  // DISABLE
  // const sideBySide = !layoutProps.gridTemplate?.includes('legend');
  const sideBySide = false;
  const transform = `translate(${sideBySide ? width - outerRadius : width / 2},${height / 2})`;
  return /*#__PURE__*/_jsx(DonutStack, {
    data: data,
    valueAccessor: valueAccessor,
    labelAccessor: labelAccessor,
    colorAccessor: colorAccessor,
    colorScale: colorScale,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    transform: transform
  });
}